var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"lang-toggle",attrs:{"title":_vm.otherLang.label},on:{"click":_vm.toggleLang}},[_c('img',{attrs:{"src":require('../../assets/img/' + _vm.otherLang.icon),"alt":_vm.otherLang.label}})])
}
var staticRenderFns = []

export { render, staticRenderFns }